import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VResponsive } from 'vuetify/lib/components/VResponsive';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMain,{staticClass:"bg",attrs:{"id":"pages"}},[_c(VImg,{class:{
      'v-image--sm': this.$vuetify.breakpoint.smAndDown,
      'v-image--md': this.$vuetify.breakpoint.mdAndDown,
    },attrs:{"src":_vm.isMobile
        ? require(("@/assets/" + (_vm.src || 'tela-login-mobile.svg')))
        : require(("@/assets/" + (_vm.src || 'tela-login.svg'))),"gradient":"to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)","min-height":"100%"}},[_c(VResponsive,{staticClass:"d-flex align-center ma-0",style:(_vm.styles),attrs:{"min-height":"72.5vh"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }